module.exports = __webpack_public_path__ + "img/GT2.070510d8.png";